import React from 'react';
import { Route } from '@reverbdotcom/commons/src/route_settings';
import {
  MY_FAVORITES_WATCH_LIST_ROUTE_PATH,
  MY_FAVORITES_SEARCHES_ROUTE_PATH,
  MY_FAVORITES_SHOPS_ROUTE_PATH,
  MY_FAVORITES_WATCH_LIST_ENDED_ROUTE_PATH,
} from '../components/shared/constants';

export const MyFavoritesWatchListRoute = (
  <Route
    key='my_favorites_watch_list'
    path={MY_FAVORITES_WATCH_LIST_ROUTE_PATH}
    props={{
      clientSide: true,
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'favorites' */
        '../components/favorites/favorites_layout_wrapper'
      ).then(m => cb(null, m.FavoritesWatchListLayoutWrapper));
    }}
  />
);

export const MyFavoritesWatchListEndedRoute = (
  <Route
    key='my_favorites_watch_list_ended'
    path={MY_FAVORITES_WATCH_LIST_ENDED_ROUTE_PATH}
    props={{
      ended: true,
      clientSide: true,
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'favorites' */
        '../components/favorites/favorites_layout_wrapper'
      ).then(m => cb(null, m.FavoritesWatchListEndedLayoutWrapper));
    }}
  />
);

export const MyFavoritesSearchesRoute = (
  <Route
    key='my_favorites_searches'
    path={MY_FAVORITES_SEARCHES_ROUTE_PATH}
    props={{
      clientSide: true,
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'favorites' */
        '../components/favorites/favorites_layout_wrapper'
      ).then(m => cb(null, m.FavoritesSearchesLayoutWrapper));
    }}
  />
);

export const MyFavoritesShopsRoute = (
  <Route
    key='my_favorites_shops'
    path={MY_FAVORITES_SHOPS_ROUTE_PATH}
    props={{
      clientSide: true,
    }}
    getComponent={(_, cb) => {
      import(
        /* webpackChunkName: 'favorites' */
        '../components/favorites/favorites_layout_wrapper'
      ).then(m => cb(null, m.FavoritesShopsLayoutWrapper));
    }}
  />
);
